import { SalesOrder_FrState } from '@proto/store/api/common/order_resources';
import { ListOrdersRequest_State } from '@proto/store/api/store/orders/orders';

export const orderTabs = Object.values(ListOrdersRequest_State)
  .filter(value => value !== ListOrdersRequest_State.STATE_UNSPECIFIED && typeof value === 'number')
  .map(value => {
    switch (value) {
      case ListOrdersRequest_State.STATE_WAIT_SELLER_SEND: {
        return $localize`待出貨`;
      }
      case ListOrdersRequest_State.STATE_WAIT_BUYER_CONFIRM: {
        return $localize`已出貨`;
      }
      case ListOrdersRequest_State.STATE_WAIT_RATING: {
        return $localize`待評價`;
      }
      case ListOrdersRequest_State.STATE_HAS_RETURN: {
        return $localize`退貨進度`;
      }
      case ListOrdersRequest_State.STATE_ALL: {
        return $localize`全部訂單`;
      }
      default: {
        return '';
      }
    }
  });

export const orderStateMap = new Map(
  Object.values(ListOrdersRequest_State)
    .filter(value => value !== ListOrdersRequest_State.STATE_UNSPECIFIED && typeof value === 'number')
    .map(value => {
      switch (value) {
        case ListOrdersRequest_State.STATE_WAIT_SELLER_SEND: {
          return [value, $localize`待出貨`];
        }
        case ListOrdersRequest_State.STATE_WAIT_BUYER_CONFIRM: {
          return [value, $localize`已出貨`];
        }
        case ListOrdersRequest_State.STATE_WAIT_RATING: {
          return [value, $localize`待評價`];
        }
        case ListOrdersRequest_State.STATE_HAS_RETURN: {
          return [value, $localize`退貨進度`];
        }
        case ListOrdersRequest_State.STATE_ALL: {
          return [value, $localize`全部訂單`];
        }
        default: {
          return [value as ListOrdersRequest_State, ''];
        }
      }
    })
);

export function getOrderTabByState(
  orderState: SalesOrder_FrState | undefined,
  waitRating = false,
  hasReturnInfoBtn = false
): string {
  if (!orderState) {
    return '';
  }
  switch (orderState) {
    case SalesOrder_FrState.FR_STATE_WAIT_BUYER_PAY:
    case SalesOrder_FrState.FR_STATE_NEW:
    case SalesOrder_FrState.FR_STATE_HANDLING: {
      // 狀態分類，待出貨：訂單狀態為，待付款、新訂單、處理中.
      return orderStateMap.get(ListOrdersRequest_State.STATE_WAIT_SELLER_SEND) ?? '';
    }
    case SalesOrder_FrState.FR_STATE_SHIPPED:
    case SalesOrder_FrState.FR_STATE_IN_TRANSIT:
    case SalesOrder_FrState.FR_STATE_DELIVERED_TO_STORE:
    case SalesOrder_FrState.FR_STATE_OUTFLOW_ERROR: {
      // 狀態分類，已出貨：訂單狀態為，已出貨、配送中、已送達、已送達門市、出貨異常.
      return orderStateMap.get(ListOrdersRequest_State.STATE_WAIT_BUYER_CONFIRM) ?? '';
    }
    case SalesOrder_FrState.FR_STATE_DELIVERED:
    case SalesOrder_FrState.FR_STATE_RECEIVED: {
      // 狀態分類，待評價：訂單狀態為，完成取件.
      if (waitRating) {
        // 有評價按鈕，但不能全部商品都已經評價.
        return orderStateMap.get(ListOrdersRequest_State.STATE_WAIT_RATING) ?? '';
      } else if (hasReturnInfoBtn) {
        // 有退貨詳情按鈕.
        return orderStateMap.get(ListOrdersRequest_State.STATE_HAS_RETURN) ?? '';
      } else {
        return orderStateMap.get(ListOrdersRequest_State.STATE_ALL) ?? '';
      }
    }
    default: {
      return orderStateMap.get(ListOrdersRequest_State.STATE_ALL) ?? '';
    }
  }
}
